import { render, staticRenderFns } from "./BlockNotes.vue?vue&type=template&id=04151696&scoped=true"
import script from "@/components/request/RequestDetail/block-notes/BlockNotes.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-notes/BlockNotes.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-notes/block-notes.scss?vue&type=style&index=0&id=04151696&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04151696",
  null
  
)

export default component.exports